/**
 * Debounce event
 */
export default {
  data: () => ({
    debounceTimeouts: {},
  }),
  methods: {
    debounce(callback, wait = 250) {
      let timeoutId = null;
      return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
          callback(...args);
        }, wait);
      };
    },
    /**
     * @param {function} callback Method to call when the timeout will be triggered
     * @param {String}   id       Id the sequence of differed call
     * @param {Number}   timeout  How long to wait before trigger
     */
    debounceDiffered(callback, id, timeout = 250) {
      if (this.debounceTimeouts[id]) {
        window.clearTimeout(this.debounceTimeouts[id]);
      }
      this.debounceTimeouts[id] = window.setTimeout(() => {
        callback();
      }, timeout);
    },
  },
};
